import React from 'react';

export default () => {
  return (
    <div role="alert">
      <p>Възникна неочаквана грешка...</p>
      <p>Изпратена е информация до съпорта на приложението и тя ще бъде разгледана.</p>
      <p>Моля презаредете страницата.</p>
    </div>
  );
};
